import React from "react";

export const GridHeader = ({ title = "", actions = [] }) => {
  // Inline styles for the GridHeader
  const headerViewStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: "25px 15px",
  };

  const titleStyle = {
    fontSize: "1.5rem",
  };

  const actionsStyle = {
    display: "flex",
    justifyContent: "space-between",
  };

  const actionButtonStyle = {
    marginRight: "1.25rem",
  };

  return (
    <div style={headerViewStyle}>
      <div style={titleStyle}>{title}</div>
      <div style={actionsStyle}>
        {actions.map((action, index) => (
          <span key={index} style={actionButtonStyle}>
            {action}
          </span>
        ))}
      </div>
    </div>
  );
};
